import {Storage, Token} from '@/utils';
import {login, common} from '@/api';

export default {
    name: 'common',
    namespaced: true,
    state: {
        company_code: '',
        token: Token.getToken(),
        isGetUserInfo: false,
        userInfo: {},
        countries: [],
        timezone: [],
        orderType: [],
        paymentType: [],
        advantageTypes: []
    },
    mutations: {},
    actions: {
        // Log in
        async Login({commit}, params) {
            try {
                const {data} = await login.login(params);
                commit('SET_STATE', {
                    userInfo: data,
                    company_code: data.company_code,
                    token: '%%$$',
                    isGetUserInfo: true
                });
                Token.setToken('%%$$');
                // A copy of user information is cached locally, and the user can actively refresh it.
                Storage.setSessionStorage('userInfo', data);
                return Promise.resolve(true);
            } catch (err) {
                throw new Error(err);
            }
        },
        // Get user information
        async GetUserInfo({commit}) {
            try {
                // The user actively refreshes and reads user data from the cache.
                const userInfo = Storage.getSessionStorage('userInfo');
                if (Storage.getSessionStorage('userInfo')) {
                    commit('SET_STATE', {
                        userInfo,
                        company_code: userInfo.company_code,
                        token: '%%$$',
                        isGetUserInfo: true
                    });
                } else {
                    // force quit
                    LogOut();
                }
            } catch (err) {
                throw new Error(err);
            }
        },
        async LogOut() {
            Token.removeToken();
            window.location.reload();
        },

        async GetCountries({commit}) {
            try {
                const { data } = await common.getCountries();
                commit('SET_STATE', { countries: data });
            } catch (err) {
                throw new Error(err);
            }
        },
        async GetTimezone({commit}) {
            try {
                const { data } = await common.getTimezone();
                commit('SET_STATE', { timezone: data });
            } catch (err) {
                throw new Error(err);
            }
        },
        async GetOrderTypes({commit}) {
            try {
                const { data } = await common.getOrderTypes();
                commit('SET_STATE', { orderType: data });
            } catch (err) {
                throw new Error(err);
            }
        },
        async GetPaymentTypes({commit}) {
            try {
                const { data } = await common.getPaymentTypes();
                commit('SET_STATE', { paymentType: data });
            } catch (err) {
                throw new Error(err);
            }
        },
        async GetAdvantageTypes({commit}) {
            try {
                const { data } = await common.getAdvantageTypes();
                commit('SET_STATE', { advantageTypes: data });
            } catch (err) {
                throw new Error(err);
            }
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js